import {UserActions} from "../const/ActionsConst";

const initialState = {
    show: false,
    error: undefined,
    username: undefined,
    password: undefined,
    retypedPassword: undefined
};

const newUser = (state = initialState, action) => {
    switch (action.type) {
        case UserActions.SHOW_NEW_USER_WND:
            return {
                ...state,
                show: action.newUser.show,
            };
        case UserActions.UPDATE_NEW_USER_DATA:
            return {
                ...state,
                [action.newUser.field]: action.newUser.value,
            };
        case UserActions.CLEAR_NEW_USER_DATA:
            return {
                ...state,
                show: false,
                error: undefined,
                username: undefined,
                password: undefined,
                retypedPassword: undefined
            };
        default:
            return state;
    }
};

export default newUser;